import { useQuery } from "@tanstack/react-query"

import { useDateParam, useResortParam } from "@/hooks/useSkipassFlow"

import { bffApi } from "../apiClient"
import formatStartDate from "../helpers/formatStartDate"
import queryKeys from "../queryKeys"

type Translations = Record<string, string>

const useWebAdminTranslationsQuery = () => {
  const { resortExternalId } = useResortParam()
  const { startDate } = useDateParam()
  const formattedDate = formatStartDate(startDate)

  return useQuery<Translations>({
    queryKey: queryKeys.webAdminTranslations(
      resortExternalId,
      formattedDate,
      ""
    ),
    queryFn: async () => {
      const res = await bffApi.get<Translations>(
        `/resorts/${resortExternalId}/webadmin-translations`,
        { params: { date: formattedDate } }
      )
      return res.data
    },
    enabled: resortExternalId !== undefined,
    staleTime: Infinity,
  })
}

export default useWebAdminTranslationsQuery
